// extracted by mini-css-extract-plugin
export default {"Container":"About_Container__BwINn","Item":"About_Item__uxO1F","subscribe":"About_subscribe__YwSN8","Text":"About_Text__Hx8IA","AboutText":"About_AboutText__kujZz"};